export const lang = {
    //公共
    document_title: '国际OA期刊学术诚信风险指数-CAR',
    common_confirm: '确定',
    common_confirm_pay: '捐赠',
    common_no_data: '暂无数据',
    common_no_data_short: '暂无',
    common_msg_dialog_title: '温馨提示',
    common_msg_login_first: '请先登录',
    common_msg_not_allow_access_first: '尚未开通相关权限，请联系',

    common_no_data_journal: '暂无数据，不是OA期刊？请<a href="/ApplyData" target="_blank">联系我们</a>收录',
    //首页
    common_global_tip_title: '温馨提示',
    common_global_tip_confirm_known: '知道了',
    common_global_tip_confirm_ok: '好的',
    //顶部
    common_header_lang: "English",
    common_header_login: "登录",
    common_header_quit: "点击注销",
    common_header_ret_home: "点击返回首页",
    common_header_ret: "返回",
    common_header_login_prompt: "每日{0}次查询机会,请合理使用",
    common_header_remain_num: "剩余次数",
    common_header_pay: "捐赠",
    common_header_exit: "退出",

    //底部
    common_contact: '联系我们',
    common_email: '邮箱',
    common_phone: '电话',
    common_links_title: '友情链接',

    //登录注册
    //公共
    common_loginbox_input_email: '请输入邮箱',
    common_loginbox_input_pass: '请输入密码',
    common_loginbox_link_login_wechat: '微信登录',
    common_loginbox_link_reg: '点击注册',
    common_loginbox_link_find_pass: '找回密码',
    common_loginbox_link_login: '点击登录',
    //登录
    common_loginbox_login_title: '登录',
    common_loginbox_login: '登录',
    jcar_login_dialog_email_label: '邮箱',
    jcar_login_dialog_password_label: '密码',
    //注册
    common_loginbox_reg_title: '邮箱注册',
    common_loginbox_send_code: '发送验证码',
    common_loginbox_input_code: '请输入邮箱验证码',
    common_loginbox_reg: '注册',
    //找回密码
    common_loginbox_reset_title: '找回密码',
    common_loginbox_input_new_pass: '请输入新密码',
    // common_loginbox_confirm:'确认',
    //错误提示
    common_loginbox_err_email: '输入的邮箱格式不正确,请重新输入',
    common_loginbox_err_pass: '密码不合法,密码为6位以上数字字母组合',
    common_loginbox_err_code: '邮箱验证码不合法,验证码为4位字母或数字',
    //消息提示
    common_loginbox_msg_login_succ: '登录成功',
    common_loginbox_msg_login_fail: '登录失败,获取用户信息失败,请重试',
    common_loginbox_msg_send_limit: '发送邮件间隔限制,请稍等一会',
    common_loginbox_msg_reg_succ: '新用户邮箱注册成功,可以通过邮箱和密码进行登录',
    common_loginbox_msg_reset_succ: '密码重置成功,自动登录成功',
    common_loginbox_msg_reset_succ_login_fail: '密码重置成功,自动登录失败,请尝试手动登录',
    common_loginbox_msg_reset_fail: '密码重置失败,请重试',
    common_loginbox_msg_send_email_fail: '发送邮件失败',
    common_loginbox_msg_send_email_succ: '发送邮件成功',
    common_loginbox_msg_code_err: '验证码错误,错误次数已达{0}次,还能重试次数{1}次',
    common_loginbox_msg_code_err_no_num: '验证码错误',
    common_loginbox_msg_login_gt_limit: '登录错误超过限制,请过会再试',
    common_loginbox_msg_login_user_in_black_list: '你的账号已被锁定,暂时无法登录使用',
    common_loginbox_msg_login_ip_in_black_list: '你的IP已被锁定,暂时无法登录使用',
    common_loginbox_msg_user_pass_err: '账号或密码错误,还能重试{0}次',
    common_loginbox_msg_user_not_exist: '用户可能不存在,请先注册',
    common_loginbox_msg_user_has_exist: '用户已存在,请登陆',
    common_loginbox_msg_reg_fail: '账号注册失败,请重新注册',
    common_loginbox_msg_logout_succ: '注销成功',
    //邮箱验证码
    common_email_titile: '邮箱验证码 by JCar',
    common_email_content: '你好，请将以下验证码 0000 输入至注册页面输入框，完成注册，谢谢。',

    pagination: {
        goto: '前往',
        pagesize: '条/页',
        total_prefix: '共',
        total_postfix: '条',
        pageClassifier: '页'
    },


    //结果部分
    figcheck_result_source_title: '可能相似的图片对: ',
    figcheck_result_source_title_no_result: '没有发现相似图片。',
    figcheck_result_ps_source_title: '可能存在ps痕迹的原图: ',
    figcheck_result_ps_source_title_no_result: '没有检测到有ps痕迹的图片。',
    figcheck_result_detail_title: '细节对比: ',
    figcheck_result_ps_detail_title: 'ps痕迹预测: ',
    figcheck_result_detail_option_show_line: '显示线',
    figcheck_result_detail_option_show_line_intro: '红线连接两张图片之间相似的特征值，帮助指示特征值之间相似的方式，如复制、旋转、反转等。',
    figcheck_result_detail_option_remove_label: '去标注',
    figcheck_result_detail_option_remove_label_intro: '图片边缘的标注部分（如图示等）将不会纳入特征值比较，去除图片标注导致的假阳性干扰。',
    figcheck_result_detail_option_ps: 'PS痕迹',
    figcheck_result_detail_option_ps_intro: '对文件中的WB图进行单独识别，类型包含针对条带的“复制，去除”2种图片操纵，经内部1000个样本测试，结果的真阳性率约为92.3%。',
    figcheck_result_single_ps_pred_prefix: '疑似',
    figcheck_result_single_ps_pred_text_add: '复制',
    figcheck_result_single_ps_pred_text_remove: '去除',
    // 提示：人工智能算法大大提高了重复图片的识别效率，但上图红线所示重复区域不代表一定是有意义的重复，比如图标，merge的荧光图等；一般，红线越聚集，重复的可能性越大。请根据实际情况判断。
    figcheck_result_ps_no_wb: '结果中无wb图,无法使用ps查询。',
    figcheck_result_detail_prompt: '温馨提示：人工智能算法大大提高了重复图片的识别效率，但上图红线所示重复区域不代表一定是有意义的重复，比如图标，merge的荧光图、缩放、零星的假阳性等，请根据实际情况判断。<a href="https://www.figcheck.com/readme?goto=ResultInterpretation" target="_blank" class="link" style="font-weight: bolder;color: #409eff;">点击查看更详细的结果判定方法</a>。',
    figcheck_result_ps_detail_prompt: 'PS痕迹检测功能经内部1000个样本测试，结果的真阳性率约为92.3%，即以上高亮区域有92.3%可能是进行了右侧所示的图片操纵类型。但仍有7.7%的假阳性，请根据实际情况判断。',
    figcheck_result_down_pdf: '下载报告',
    figcheck_result_downing_pdf: '生成中...',


    //carindex 列表页
    jcar_first_case_prompt: "按期刊名首写字母查看",
    jcar_search_journal_name: "期刊名",
    jcar_search_issn: "ISSN",
    // jcar_search_research_area:"研究方向",
    jcar_search_if: "影响因子", //IF
    // jcar_search_sci_included:"SCI收录",
    // jcar_search_big_cat:"大类学科",
    // jcar_search_small_cat:"小类学科",
    jcar_search_part: "中科院分区",
    jcar_search_unlimit: "不限",
    // jcar_search_is_oa:"是否OA期刊",
    // jcar_search_result_sort:"结果排序",
    jcar_search_btn: "搜索",
    jcar_search_result_first_letter_prefix: "字母",
    jcar_search_result_first_letter_postfix: "开头的期刊共有",
    jcar_table_col_issn: "ISSN",
    jcar_table_col_journal_name: "期刊名",
    jcar_table_col_car_index: "CAR 指数",
    jcar_table_col_car_index_explain: "CAR指数是期刊当年涉及学术诚信风险的文章数相对于当年发表量的比值，数值越高期刊相对学术诚信风险越高。",
    jcar_table_col_car_index_growth_rate_not_applicable: "无",
    jcar_table_col_car_index_growth_rate_explain: "CAR指数实时增速指的是当年相比上一年度的实时占比，数值越大说明该期刊诚信状态恶化明显。",
    jcar_table_col_sci_risk_rank: "被踢风险",
    jcar_table_col_sci_risk_rank_explain: "被踢风险是根据CAR指数高低，预测出的期刊被科睿唯安官方剔除SCI的风险分级，CAR指数越高，风险越大。",
    jcar_table_col_sci_risk_rank_high_ifs_explain: "该数据偏高源于PubPeer上对该期刊多篇文章的评论，CAR指数仅记录该数据，评论内容是否涉及违反学术诚信的问题，请点击按钮查看详情。",
    jcar_table_col_ifs: "影响因子",
    jcar_table_col_part: "中科院分区",
    jcar_table_col_part_postfix: "区",
    // jcar_table_col_subject:"学科领域",
    // jcar_table_col_big_cat:"大类",
    // jcar_table_col_small_cat:"小类",
    // jcar_table_col_sci_included:"SCI收录",
    // jcar_table_col_is_oa:"是否OA",
    // jcar_table_col_employment_ratio:"录用比例",
    // jcar_table_col_review_cycle:"审稿周期",
    jcar_table_col_view_num: "查看数",
    jcar_top_20_focuesd_journals: "受关注期刊",

    //详情页
    jcar_detail_title_postfix: "学术诚信风险概览",
    jcar_detail_base_info: "基本信息",  //  待确认
    jcar_detail_car_index: "CAR指数",
    jcar_detail_car_index_real_time: "实时",
    jcar_detail_delist_risk: "被踢风险",
    jcar_detail_last_ifs: "最新影响因子",
    jcar_detail_updown: "涨跌",
    jcar_detail_none_ifs: "官方未公布",
    jcar_detail_last5year: "近5年",
    jcar_detail_part: "中科院",
    jcar_detail_part_postfix: "区",
    jcar_detail_Country: "国家",
    jcar_detail_publisher: "出版社",
    jcar_detail_journal_intro: "期刊简介",
    jcar_detail_offical_website: "期刊官方网站",
    jcar_detail_submission_website: "期刊投稿网址",
    jcar_detail_intro_retraction: "文章撤稿是期刊的主动行为，从维护学术诚信的角度来说是正面的。但显然也是代表期刊文章的质量问题受到了质疑，因此对期刊学术诚信造成损害。最近一年撤稿数量明显比之前增加的期刊将被重点关注。撤稿数量和幅度纳入CAR指数的计算权重中。",
    jcar_detail_intro_pubpeer: "期刊上的文章被其他学者质疑和曝光，并不一定代表该文章有问题，但例如Pubpeer等平台的曝光，通常代表该文章出现了困惑和问题，因此对期刊的学术诚信造成损害。最近一年质疑数量明显比之前增加的期刊将被重点关注。被质疑的文章数量纳入CAR指数的计算权重中。",
    jcar_detail_intro_figcheck: "图像重复问题日益受到关注。自2024年起，由STM诚信中心（STM Integrity Hub）官网收录的图片重复检测工具，已开始被用于对OA期刊文章中的图像进行筛查，所有筛查结果由人工复核，只有确认违反学术规范的图片重复才会被记录。注意，由于图片重复的复杂性，无法实现100%的阳性检测率。",
    jcar_detail_intro_reference_author: "期刊上的文献所涉及的学术诚信风险值得关注，包括某一作者可能涉及其他问题文献的发表，参考文献涉及学术诚信问题，都会增加该文献和对应期刊的学术诚信风险。但由于存在因为数据格式造成的“误判”，两者暂不纳入CAR指数的计算权重中。",
    jcar_detail_intro_share_email: "文章某一作者存在和其他机构不同作者共用通讯邮箱的情况，这通常是论文工厂的特征，但由于作者标注和机构标注的多样性，我们在此只作为标注，由使用者自行判断。该数据不纳入CAR指数的计算权重中。",
    jcar_detail_intro_share_email_item_prompt: "*不同机构作者使用同一邮箱投稿，是'论文工厂'的特征之一。上述结果为大数据统计结果，不代表一定涉及，比如作者换单位，或者同一课题组统一使用某邮箱作为通讯邮箱，或者因为作者名字、机构的不同写法等，请自行判断。",
    jcar_detail_intro_org_warning: "期刊被中国任何机构设定为不建议投稿名单或者预警期刊，极大损害期刊的声誉和学术诚信。该数据仅来着中国，不纳入CAR指数的计算权重中。但往往机构的评估一定程度上，是基于学术界对期刊质量和声誉的客观反应。",
    jcar_detail_intro_in_scope: "期刊接收发表大量和期刊接收范围不符的文章，往往是掠夺性期刊的特征，也受到科睿唯安的重点关注。这一数据被纳入CAR指数的计算当中。",
    jcar_detail_title_retraction: "期刊撤稿概况年度分布",
    jcar_detail_title_pubpeer: "文章被质疑/曝光概况",
    jcar_detail_title_figcheck: "Figcheck图片查重实时数据文章年度分布",
    jcar_detail_title_scope: "不在收稿范围",
    jcar_detail_title_reference: "参考文献诚信风险",
    jcar_detail_title_author: "文章作者诚信风险",
    jcar_detail_title_share_email: "共用通讯邮箱情况",
    jcar_detail_title_org_warning: "中国机构警示概况",
    jcar_detail_retraction: "撤稿",
    jcar_detail_publication_data: "发布日期",
    jcar_detail_problem_type: "问题类型",
    jcar_detail_literature_type: "文献类型",
    jcar_detail_authors: "作者",
    jcar_detail_institution: "机构",
    jcar_detail_journal: "期刊",
    jcar_detail_before: "前",
    jcar_detail_type_pubeer: "pubpeer曝光",
    jcar_detail_type_figcheck: "figcheck筛查",
    jcar_detail_focus_reference: "关注参考文献",
    jcar_detail_focus_author: "关注作者",
    jcar_detail_same_email_author: "共用人",
    jcar_detail_same_email_author_prompt: "该文献有以下作者，和非同机构的其他作者共用邮箱",
    jcar_detail_org_issue_institution: "发布机构",
    jcar_detail_org_warning: "警示等级",
    jcar_detail_org_warning_low: "低",
    jcar_detail_org_warning_middle: "中",
    jcar_detail_org_warning_high: "高",
    jcar_detail_org_origin: "来源标题",
    jcar_detail_year: "年前",
    jcar_detail_month: "月前",
    jcar_detail_week: "周前",
    jcar_detail_day: "天前",
    jcar_detail_hour: "小时前",
    jcar_detail_minute: "分钟前",
    jcar_detail_second: "秒前",
    jcar_detail_view_all: "查看全部",
    jcar_detail_view_reset: "重置",

    jcar_detail_btn_data_export: "导出",

    jcar_detail_figcheck_link_to: "Figcheck详情",
    jcar_detail_pubpeer_link_to: "Pubpeer详情",

    jcar_detail_pubpeer_comment_title: "匿名评价",
    jcar_detail_pubpeer_comment_prefix: "于",
    jcar_detail_pubpeer_comment_postfix: "评论",

    // 指数介绍
    jcar_footer_intr_btn: "期刊CAR指数介绍",

    jcar_intro_text_1_1: "指数介绍",
    jcar_intro_text_1_2: "国际OA期刊学术诚信风险指数，简称“CAR (Comprehensive Academic Integrity Risk) index, 是一套面向国际开放获取（Open Access，OA）期刊，以学术诚信为核心维度的量化评估工具。本指数通过动态追踪期刊的撤稿数量、图像重复、出版后学术质疑等数据，构建多维度、可量化的风险识别体系，旨在为科研诚信管理和期刊评价提供客观参考。",
    jcar_intro_text_1_3: "发布背景",
    jcar_intro_text_1_4: "近年来，我国持续加强科研诚信体系建设。2018年，中共中央办公厅、国务院办公厅印发《关于进一步加强科研诚信建设的若干意见》，明确提出建立健全学术期刊管理和预警制度，支持相关机构发布国际学术期刊预警名单。这一顶层设计直接催生了建立量化、动态风险指数的需求，本指数正是对这一“预警制度”在技术层面和量化层面上的深化与落地。2020年，教育部与科技部联合印发《关于规范高等学校SCI论文相关指标使用树立正确评价导向的若干意见》，推动科研评价从“重数量”向“重质量”转变。传统的期刊评价体系往往忽略了期刊的出版伦理安全和学术质量控制能力。本指数将关注点从“影响力”拉回“公信力”，为科研管理部门提供了一个衡量期刊“信噪比”的客观工具。",
    jcar_intro_text_1_5: "与此同时，开放获取出版模式快速发展，部分期刊在商业化驱动下出现审稿流程不严、掠夺性出版、论文工厂批量生产等问题。传统的期刊评价指标（如影响因子）难以有效反映期刊的学术诚信风险。因此，构建一套以诚信风险为核心的新型评价工具，具有重要的现实意义。\n",
    jcar_intro_text_1_6: "指数定位与用途",
    jcar_intro_text_1_7: "本指数定位于学术诚信风险预警工具，主要服务于以下场景：",
    jcar_intro_text_1_8: "科研管理：为高校、科研院所及科技管理部门识别高风险OA期刊提供量化依据；",
    jcar_intro_text_1_9: "投稿参考：帮助科研人员在选择期刊时评估其学术安全性与可信度；",
    jcar_intro_text_1_10: "经费监管：减少因发表在高风险期刊上导致的科研经费浪费和学术声誉损失；",
    jcar_intro_text_1_11: "生态引导：推动国际OA期刊重视审稿质量和出版伦理，促进学术出版健康发展。",
    jcar_intro_text_1_12: "本指数基于客观数据，动态更新，供科研管理部门、研究机构及科研人员参考使用。",
    jcar_intro_text_3: "CAR是Comprehensive Academic integrity Risks的简写，意为通过多个类型数据对期刊的学术诚信风险进行一个全面的评估。期刊CAR指数平台（jcarindex.com）是一个评价SCI期刊学术诚信风险（CAR）的数据平台，由注册在中国杭州的一家创新型公司Home for researchers开发维护，其自2018年成立以来，一直致力于中国科研人员科研效率的提升。",
    jcar_intro_text_4: "期刊CAR指数平台汇总哪些数据？",
    jcar_intro_text_4_intro: "我们收集的数据类型包括基本的期刊信息和与学术诚信相关的数据。",
    jcar_intro_text_4_intro_node_1: "1. 当年的撤稿文章数量",
    jcar_intro_text_4_intro_node_1_desc: "期刊具有主动撤稿的权力，这有助于维护学术诚信。然而，撤稿也会对期刊造成一定威胁，因为这意味着期刊论文的质量受到质疑。如果某期刊在某一年度的撤稿数量远高于往年，将会引起更多关注。",
    jcar_intro_text_4_intro_node_2: "2. 当年在Pubpeer等平台上被曝光的文章数量",
    jcar_intro_text_4_intro_node_2_desc: "被质疑的期刊论文并不一定都有问题。然而，在如 PubPeer 等平台上被曝光的论文通常存在疑点或争议，表现出问题与混乱，这会损害论文发表期刊的学术声誉。如果某期刊在某一年度被质疑的论文数量远高于往年，将会引起更多关注。",
    jcar_intro_text_4_intro_node_3: "3. 涉及图片重复的文章数量",
    jcar_intro_text_4_intro_node_3_desc: "图像重复问题正受到越来越多的关注。自 2024 年以来，STM Integrity Hub 官方网站上介绍的图像重复检测工具被用于筛查开放获取（OA）期刊论文中的图像。所有筛查结果均经过人工复核，只有经确认违反学术诚信的图像重复才会被记录。请注意，由于图像重复问题的复杂性，目前尚无法实现 100% 的准确检测率。",
    // jcar_intro_text_4_intro_node_4:"4. 超出期刊范围的已发表文章的年度分布",
    jcar_intro_text_4_intro_node_4: "4. 作者涉及学术诚信问题的文章的年度分布",
    jcar_intro_text_4_intro_node_4_desc: "应当高度重视文献中涉及的学术诚信风险，包括作者可能参与发表其他存在问题的文献，以及引用文献本身存在学术诚信问题的情况。这些因素可能会损害文献及其所属期刊的学术诚信。然而，由于数据格式可能导致的“误判”，这两项因素暂时未被纳入 CAR 指数的计算权重中。",
    jcar_intro_text_4_intro_node_5: "5. 引用文献涉及学术诚信问题的文章的年度分布",
    jcar_intro_text_4_intro_node_5_desc: "应当高度重视文献中潜在的学术诚信风险，包括作者可能参与发表其他存在问题的文献，以及引用的文献本身存在学术诚信问题。这些因素可能会损害该文献及其所属期刊的学术诚信。然而，由于数据格式可能导致的“误判”，这两项因素目前暂未纳入 CAR 指数的计算权重。",
    // jcar_intro_text_4_intro_node_7:"6. 通讯作者邮箱由来自不同机构的两位作者共享的文章的年度分布",
    // jcar_intro_text_4_intro_node_8:"7. 该期刊是否被中国的任何机构标注为可疑期刊或不推荐投稿的期刊",

    jcar_intro_text_5: "期刊CAR指数平台包含期刊的基本信息，和如下和学术诚信相关的数据：当年被撤稿文章数量，当年被Pubpeer等同行评议平台曝光的文章数量，被Figcheck图片查重系统发现图片重复的文章年度分布、超出期刊收稿范围的文章年度分布，作者涉及学术诚信问题的文章年度分布，参考文献涉及学术诚信问题的文章年度分布，不同机构不同作者共用通讯邮箱的文章年度分布，被中国机构纳入黑名单的情况。",
    jcar_intro_text_6: "期刊CAR指数如何计算？",

    jcar_intro_text_6_CAR: "J-CAR 指数",
    jcar_intro_text_6_r: "撤稿文章数量",
    jcar_intro_text_6_p: "在Pubpeer等平台上被曝光的文章数量",
    jcar_intro_text_6_f: "被检测出存在图片重复使用的文章数量",
    jcar_intro_text_6_n: "该期刊当年的已发表文章数量",

    jcar_intro_text_7: "当年被撤稿文章的文章数+当年被Pubpeer等曝光的文章数+当年被Figcheck发现图片重复的文章数+当年超出期刊收稿范围的文章数/期刊当年发文量。",
    jcar_intro_text_8: "因此期刊CAR指数是一个相对风险比值，比值越高代表该期刊当年的学术诚信风险相对于当年发表文章数来说比值越高。由于当年被曝光学术诚信风险的文章和当年发表的文章并不一致，因此CAR指数可以大于1。",
    jcar_intro_text_9: "在32本最近被科睿唯安剔除的SCI期刊中（3本期刊因为停刊而被剔除），19本期刊的2022年度CAR指数或2023年实时CAR指数超过10%，因此10%被设定为高风险（期刊被剔除的风险）的截止。值得注意的是，当将CAR指数纳入文章是否超出期刊Scope的因素后，除了REVISTA BRASILEIRA DE MEDICINA DO ESPORTE，其他31本期刊的2022年CAR指数或2023年实时CAR指数都大于10%。因此，虽然考虑到交叉学科等一些原因，文章是否符合期刊scope需要经过专家委员会的评估，因此\"out of scope\"并没有被纳入CAR指数的计算，但基于人工智能的初步判定可以给用户提供参考。",
    jcar_intro_text_9_bottom_intro: "由于数据是动态录入的，可能出现变化，请以在线版本为准。",
    jcar_intro_text_10: "35本期刊CAR指数数据",

    jcar_intro_text_101: "风险评级规则",
    jcar_intro_text_102: "根据以上风险评级规则，经过优化，形成了以下风险设定规则：",
    jcar_intro_text_103: "1. 如果前一年或当年的 JCAR 指数大于 10%，则标记为高风险；介于 5% 到 10% 之间为中等风险；低于 5% 为低风险。",
    jcar_intro_text_104: "2. 如果当年的 JCAR 指数与前一年的比值大于 2，且当年学术诚信事件数量大于 10，则视为高风险；介于 5 到 10 之间为中等风险；少于 5 为低风险。",
    jcar_intro_text_105: "3. 如果前一年的 JCAR 指数为 0，则仅考虑当年学术诚信事件的数量。0–5 表示低风险，5–10 表示中等风险，大于 10 表示高风险。",
    jcar_intro_text_106: "4. 不同规则最终取最高风险等级作为最终风险等级。",

    jcar_intro_text_11: "机构如何订阅期刊CAR指数？",
    jcar_intro_text_12: "CAR指数平台的数据不对外开发，只针对出版社，期刊编辑等机构用户内部监控期刊学术诚信风险使用。对某个期刊完整数据有需求的用户，可以联系我们开通权限。由于需要人工二次确认，一般来说，某个期刊的数据整理需要3-7天时间。",
    jcar_intro_text_13: "权限开通后，机构用户登录后可以查看该期刊的各项数据、以表格形式下载相关文章、设置邮箱预警条件及时通知，对于图片查重数据，由于其是实时监控的结果，因此可以及时通知相关作者，联系出版社勘误。",
    jcar_intro_text_14: "出版社也可以申请将CAR指数接口接入稿件提交系统，对稿件进行全面的学术诚信风险评估，内容包括：文字重复率（可选），图片重复情况、作者是否涉及其他学术诚信文章，参考文献是否涉及学术诚信问题文章，稿件是否符合期刊收稿范围，通讯邮箱和其他机构的他人有重叠的情况。",
    jcar_intro_text_15: "期刊CAR指数的局限性？",
    jcar_intro_text_16: "期刊CAR指数风险评估的是期刊的学术诚信风险，虽然在最近35本被科睿唯安剔除的期刊上得到了印证，但不代表CAR指数就一定能预测期刊被剔除的风险。根据CAR指数的建议投稿或者不投稿产生的潜在结果，与CAR指数平台无关。",

    // car project
    jcar_project_title: "CAR Project成员资格",
    jcar_project_sub_title_1: "CAR Project",
    jcar_project_text_1: "期刊和论文学术诚信问题近年来受到学术界的广泛关注。CAR Project是CAR指数平台推出的一项维护学术界期刊/论文学术诚信的公益倡议。CAR Project招募有相同理念的期刊/出版社等机构加入。",
    jcar_project_sub_title_2: "会员优势",
    jcar_project_text_2_1: "1. CAR指数平台将无偿为会员提供8大类型的有关期刊学术诚信的实时监控数据，以及邮件提醒服务；",
    jcar_project_text_2_2: "2. 无偿提供的稿件学术诚信评估系统（MCAR系统）；",
    jcar_project_text_2_3: "3. CAR指数平台基于目前庞大的用户量（超过150万），无偿为会员提供力所能及的期刊诚信数据方面的个性化服务，如期刊声誉调研问卷报告等。",
    jcar_project_sub_title_3: "会员对象",
    jcar_project_text_3_1: "目前只针对期刊/出版社等机构开放，不向个人开放",
    jcar_project_sub_title_4: "会员费用",
    jcar_project_text_4_1: "CAR项目和CAR指数平台一样，都是公益项目，不会收取任何费用。",
    jcar_project_sub_title_5: "会员资格审核和申请",
    jcar_project_text_5_1: "1. 请准备材料说明已有相应措施来维护期刊/论文的学术诚信完整性",
    jcar_project_text_5_2: "2. 请联系 admin@jcarindex.com",
    jcar_project_sub_title_6: "成员logo",
    jcar_project_text_6_1: "会员将被授权在其官网或宣传媒介使用Member of CAR Project的标识，如下：",
    jcar_project_text_down_logo: "下载高清logo",

    jcar_header_home: "首页",
    jcar_header_intro: "介绍",
    jcar_header_qa: "Q&A",
    jcar_header_data_share: "数据共享",
    jcar_header_about_us: "FAIR",
    jcar_header_committee: "专家委员会",

    jcar_data_share_left_title: "数据共享协议",
    jcar_data_share_node_1_title: "1. 使用权限：",
    jcar_data_share_node_1_content: "本平台数据仅限于非商业用途。未经授权，任何机构或个人不得将本数据用于商业目的。",
    jcar_data_share_node_2_title: "2. 引用规范：",
    jcar_data_share_node_2_content: "使用本平台数据时，须在研究成果或出版物中明确标注数据来源，并注明数据获取日期。引用格式如下：中国高校科技期刊研究会诚信专委会-苏州协同开放科学研究中心“开放科学与学术诚信”联合实验室.国际OA期刊学术诚信风险指数CAR（CAR Journal Index）[DB/OL].(更新日期)[引用日期].https://www.carindex.org.cn.",
    jcar_data_share_node_3_title: "3. 免责声明：",
    jcar_data_share_node_3_content: "本平台所提供的信息仅供学术共同体各方参考。任何第三方机构因使用本平台信息所产生的直接或间接后果，平台不承担任何连带责任。",
    jcar_data_share_node_4_title: "4. 数据查看与核实：",
    jcar_data_share_node_4_content: "出版社可申请查看期刊的详细数据，并作出评论或反驳。例如，若某篇文章在PubPeer上的讨论经确认不涉及学术诚信问题，该条记录将被移除，CAR指数也将随之更新。",
    jcar_data_share_left_update_date: "数据更新时间：",

    jcar_data_share_right_title: "获取数据",
    jcar_data_share_right_email: "邮箱",
    jcar_data_share_right_org_name: "机构名称",
    jcar_data_share_right_name: "姓名",
    jcar_data_share_right_phone: "联系电话",
    jcar_data_share_right_agree: "已阅读并同意数据共享协议",
    jcar_data_share_right_btn: "提交",

    jcar_data_share_msg_email: "请输入您的邮箱",
    jcar_data_share_msg_org_name: "请输入您的机构名称",
    jcar_data_share_msg_name: "请输入您的姓名",
    jcar_data_share_msg_phone: "请输入您的手机号码",
    jcar_data_share_msg_agree: "请先同意数据共享协议",

    jcar_data_share_msg_succ: "提交成功",
    jcar_data_share_msg_fail: "提交失败",

    carindex_profile_comment_empty: "请输入评论内容",
    carindex_profile_comment_submitted: "已提交，待审核后展示",

    jcar_home_title: "国际OA期刊学术诚信风险指数",
    jcar_home_title_intro: "CAR",
    jcar_home_date_update: "数据更新时间：",
    jcar_home_type_journal_name: "期刊名称",
    jcar_home_input_hint: "请输入搜索内容",
    jcar_home_btn: "查找期刊",

    jcar_qa_title: "常见问题解答（FAQ）",
    jcar_qa_01_q: "1. 什么是“国际OA期刊学术诚信风险指数”？",
    jcar_qa_01_a: "该指数是一套面向国际开放获取（OA）期刊、以学术诚信为核心的量化评估工具。它通过动态追踪期刊的撤稿数量、图像重复、出版后学术质疑等数据，评估期刊在学术诚信方面的风险水平。",
    // jcar_qa_02_q: "2. 为什么评估范围没有纳入中国机构主办的英文OA期刊？",
    // jcar_qa_02_a: "本指数由中国机构发布，为保持指数的公信力，避免对本土期刊可能产生的无意识倾斜或压力，本指数现阶段不纳入中国机构主办的英文期刊，而将评估范围限定在与中国机构无直接主办关系的国际OA期刊。",
    jcar_qa_03_q: "2. 该指数与传统的期刊评价指标（如影响因子）有何不同？",
    jcar_qa_03_a: "传统指标主要关注期刊的引用影响力，而本指数聚焦于学术诚信风险。本指数旨在为科研人员和管理者提供一个独立于影响因子之外的安全评估维度。",
    jcar_qa_04_q: "3. 指数的数据来源是什么？",
    jcar_qa_04_a_01: "本指数基于公开可获取的学术记录数据，主要包括：",
    jcar_qa_04_a_02: "撤稿观察数据库（Retraction Watch）",
    jcar_qa_04_a_03: "学术诚信筛查工具（如由STM诚信中心收录的图片重复检测工具）",
    jcar_qa_04_a_04: "出版后同行评议平台（如PubPeer）",
    jcar_qa_04_a_05: "其中图片重复检测结果经过人工复核，仅纳入确认违反学术规范的结果。",

    jcar_qa_05_q: "4. 指数多久更新一次？",
    jcar_qa_05_a: "本指数动态更新。",
    jcar_qa_06_q: "5. 如何使用本指数？",
    jcar_qa_06_a: "本指数反映相对的期刊学术诚信风险，指数越高，期刊学术诚信风险相对越高。高风险期刊指的是在多个学术诚信维度上出现明显异常信号的期刊。科研人员投稿时应高度谨慎；科研管理部门在绩效考核、经费报销、职称评定等场景中，可参考本指数作为风险判断依据之一，如推荐仅向CAR指数低于10%的期刊投稿。",
    jcar_qa_07_q: "6.为什么有些高影响因子期刊的CAR指数很高？",
    jcar_qa_07_a: "本指数和传统影响因子(被引次数)是不同的评估维度，影响因子高的期刊并不等同于学术诚信风险低。",
    jcar_qa_08_q: "7. CAR指数的局限性？",
    jcar_qa_08_a_01: "CAR指数在反映期刊学术诚信风险存在天生的局限性：",
    jcar_qa_08_a_02: "图像重复检测无法实现100%的阳性检测率",
    jcar_qa_08_a_03: "撤稿数据可能存在上报延迟",
    jcar_qa_08_a_04: "部分学术质疑尚未形成最终结论，甚至未涉及学术诚信问题",
    jcar_qa_08_a_05: "仅上述维度亦无法完全代表期刊整体学术诚信状态",
    jcar_qa_08_a_06: "因此，本指数提供的是风险提示而非最终判定，建议结合其他信息综合使用。",
    jcar_qa_09_q: "8. 科研人员如何利用该指数？",
    jcar_qa_09_a_01: "投稿前：查询目标期刊的风险指数，在有多个同等条件期刊选择时，建议选择风险指数低的期刊",
    jcar_qa_09_a_02: "成果评价：在职称评定、毕业审核等场景中，作为期刊安全性参考",
    jcar_qa_09_a_03: "经费管理：辅助判断是否对发表在特定期刊上的论文予以版面费报销",
    jcar_qa_10_q: "9. 期刊出版商如何应对某本期刊CAR指数较高的情况？",
    jcar_qa_10_a: "本指数基于客观数据，平台鼓励期刊主动提升学术诚信管理标准，鼓励在平台发布解释性文档，我们将予以公开展示。",
    jcar_qa_11_q: "10. 该指数是否收费？",
    jcar_qa_11_a: "本指数完全免费面向公众开放，旨在服务科研诚信体系建设，不涉及任何商业收费或期刊排名商业化合作。",
    jcar_qa_12_q: "11. 如何获取更多信息或提出建议？",
    jcar_qa_12_a: "请至“数据共享”页面。",

    jcar_about_us_tab_01:"联合体简介",
    jcar_about_us_tab_02:"联合体架构",
    jcar_about_us_tab_03:"联合体章程",
    jcar_about_us_tab_04:"成员单位",

    jcar_about_us_intro_title: "负责任研究与学术诚信联合体简介",
    jcar_about_us_intro_para_01: "为深入贯彻落实习近平总书记关于弘扬科学家精神、加强科研诚信建设的重要指示精神，积极回应联合国教科文组织《开放科学建议书》中关于学术诚信与透明度的核心要求，推动中国在全球学术治理中发挥建设性作用，拟成立负责任研究与学术诚信联合体（以下简称“联合体”）。联合体将以国际OA期刊学术诚信指数的发布为起点，构建面向全球的学术诚信评估与治理体系。现制定方案如下。",
    jcar_about_us_intro_para_02_title: "一、愿景宗旨",
    jcar_about_us_intro_para_02_content_01: "秉持共商、共建、共享的理念，搭建一个开放、公正、透明、负责任的学术诚信交流平台。以国际OA（开放获取）期刊学术诚信指数的系统发布为核心抓手，推动学术出版从“数量导向”向“诚信导向”转型，营造诚实守信、公平竞争、协同治理的学术生态，助力我国及全球科研系统在开放科学时代实现高质量发展与可持续创新。",
    jcar_about_us_intro_para_03_title: "二、组织机构",
    jcar_about_us_intro_para_03_content_01: "成员单位：联合体根据工作和业务开展需要，吸收国内外相关科技团体、科研机构（数据中心）、科技情报机构、出版机构、学术基金会及科研诚信管理部门等各类学术诚信利益相关主体作为成员单位。",
    jcar_about_us_intro_para_03_content_02: "理事会：理事会采取席位制，每个成员单位委派1位代表作为理事，共同组成理事会。设理事长1人，由在科研诚信与学术出版领域享有盛誉的国内外科学家或学者担任；设常务副理事长1人，负责理事会日常运营管理。理事会每届任期3年。",
    jcar_about_us_intro_para_03_content_03: "常务理事会：由理事长、常务副理事长、秘书长、常务副秘书长、专项组组长及副组长单位理事组成。",
    jcar_about_us_intro_para_03_content_04: "秘书处：秘书处由成员单位委派工作人员组成，办公室设在牵头单位。设秘书长1位、常务副秘书长1位，由理事会任命。秘书处每届任期3年。",
    jcar_about_us_intro_para_03_content_05: "专项组：由成员单位自愿加入，重点围绕“指数研究与发布”、“数据审计与核验”、“政策与标准制定”、“违规案例追踪”等方向设立专项组。专项组设组长及副组长单位各1个，由秘书处提名，经理事长及常务副理事长批准后产生。",
    jcar_about_us_intro_para_04_title: "三、运行机制",
    jcar_about_us_intro_para_04_content_01: "联合体以理事会作为最高决策机构，负责联合体章程修改、年度工作规划、成员单位加入、秘书长及常务副秘书长任命等重大事项的决策。",
    jcar_about_us_intro_para_04_content_02: "理事会下设常务理事会，常务理事会会议根据工作需要不定期召开，负责协调各专项组开展工作，并检查工作推进及落实情况。",
    jcar_about_us_intro_para_04_content_03: "理事会下设秘书处，负责联合体日常工作。",
    jcar_about_us_intro_para_04_content_04: "理事会根据年度工作规划设立专项组，专项组根据联合体年度工作规划制定工作组计划，经报常务理事会通过后，由组长单位牵头组织实施。",
    jcar_about_us_intro_para_05_title: "四、工作任务",
    jcar_about_us_intro_para_05_content_01: "联合体的主要任务包括以下事项：",
    jcar_about_us_intro_para_05_content_01_sub_title: "发布国际OA期刊学术诚信指数",
    jcar_about_us_intro_para_05_content_01_sub_content: "系统采集全球开放获取期刊的撤稿记录、图像伪造、同行评议操纵、作者身份异常等公开数据，构建多维度、可验证的学术诚信指标体系，定期发布国际OA期刊学术诚信指数排名与风险预警报告，为科研人员、资助机构及评价体系提供可信参考。",
    jcar_about_us_intro_para_05_content_02_sub_title: "推动学术诚信跨界治理",
    jcar_about_us_intro_para_05_content_02_sub_content: "搭建科研机构、出版单位、图书馆、基金委、期刊数据库等多方参与的协作平台，建立学术不端信息的快速通报与联合处置机制，打破“问题期刊”与“问题论文”的信息孤岛。",
    jcar_about_us_intro_para_05_content_03_sub_title: "促进负责任开放获取实践",
    jcar_about_us_intro_para_05_content_03_sub_content: "倡导并支持高质量的开放获取出版，区分“合规OA”与“掠夺性期刊”，推动科研评价体系从简单计量向诚信加权转型，引导中国学者选择负责任的OA期刊发表成果。",
    jcar_about_us_intro_para_05_content_04_sub_title: "制定学术诚信评估标准",
    jcar_about_us_intro_para_05_content_04_sub_content: "研究并发布期刊学术诚信评估团体标准，包括数据核验流程、撤稿追踪规范、指数计算方法等，推动相关标准在国内科技评价、职称评审、项目评审等环节的采纳与应用。",
    jcar_about_us_intro_para_05_content_05_sub_title: "畅通咨商与培训渠道",
    jcar_about_us_intro_para_05_content_05_sub_content: "面向科研人员、研究生、期刊编辑等群体开展学术诚信培训，为政府、科研单位及国际组织提供关于OA期刊治理与诚信风险防控的咨询建议，提升我国在开放科学时代学术治理中的话语权。",
    jcar_about_us_intro_para_05_content_02: "为实现联合体宗旨所开展的其他相关工作。",

    jcar_about_us_org_structure_title: "负责任研究与学术诚信联合体架构",

    jcar_about_us_intro_charter_title:"负责任研究与学术诚信联合体章程",
    jcar_about_us_intro_charter_sub_title:"（修订稿）",
    jcar_about_us_intro_charter_para_01_title:"第一章 总则",
    jcar_about_us_intro_charter_para_01_content_01:"第一条 为积极响应联合国教科文组织《开放科学建议书》中关于学术诚信与透明度的核心要求，落实国家关于弘扬科学家精神、加强科研诚信建设的决策部署，推动构建全球学术诚信治理体系，由学术诚信与版权工作委员会和苏州协同开放科学研究中心共同发起，倡议成立“负责任研究与学术诚信联合体”（FAIR，即 Federation/Consortium for Academic Integrity & Responsibility，以下简称“联合体”或“FAIR”）。为保证联合体及相关工作的正常运行，特制定本章程。",
    jcar_about_us_intro_charter_para_01_content_02:"第二条 FAIR 是协调学术诚信评估与治理事务的开放性、非营利、非法人组织，旨在以国际OA期刊学术诚信指数的发布为核心抓手，推动学术出版从“数量导向”向“诚信导向”转型，营造诚实守信、公平竞争、协同治理的学术生态，为搭建开放、公正、透明、负责任的学术诚信交流平台提供指导、建议和可行方案。",
    jcar_about_us_intro_charter_para_01_content_03:"第三条 FAIR 的主要任务包括以下事项：",
    jcar_about_us_intro_charter_para_01_content_03_sub_title:"发布国际OA期刊学术诚信指数",
    jcar_about_us_intro_charter_para_01_content_03_sub_content:"系统采集全球开放获取期刊的撤稿记录、图像伪造、同行评议操纵、作者身份异常等公开数据，构建多维度、可验证的学术诚信指标体系，定期发布指数排名与风险预警报告。",
    jcar_about_us_intro_charter_para_01_content_04_sub_title:"推动学术诚信跨界治理",
    jcar_about_us_intro_charter_para_01_content_04_sub_content:"搭建科研机构、出版单位、图书馆、基金委、期刊数据库等多方参与的协作平台，建立学术不端信息的快速通报与联合处置机制。",
    jcar_about_us_intro_charter_para_01_content_05_sub_title:"促进负责任开放获取实践",
    jcar_about_us_intro_charter_para_01_content_05_sub_content:"倡导并支持高质量的开放获取出版，区分“合规OA”与“掠夺性期刊”，推动科研评价体系从简单计量向诚信加权转型。",
    jcar_about_us_intro_charter_para_01_content_06_sub_title:"制定学术诚信评估标准",
    jcar_about_us_intro_charter_para_01_content_06_sub_content:"研究并发布期刊学术诚信评估团体标准，推动相关标准在科技评价、职称评审、项目评审等环节的采纳与应用。",
    jcar_about_us_intro_charter_para_01_content_07_sub_title:"畅通咨商与培训渠道",
    jcar_about_us_intro_charter_para_01_content_07_sub_content:"面向科研人员、研究生、期刊编辑等群体开展学术诚信培训，为政府、科研单位及国际组织提供关于OA期刊治理与诚信风险防控的咨商建议。",
    jcar_about_us_intro_charter_para_01_content_04:"为实现联合体宗旨所开展的其他相关工作。",
    jcar_about_us_intro_charter_para_02_title:"第二章 组织机构",
    jcar_about_us_intro_charter_para_02_content_01:"第四条 FAIR 根据工作和业务开展需要，吸收国内外相关科技团体、科研机构（数据中心）、科技情报机构、出版机构、学术数据库、科研资助机构、科研诚信组织等各类学术诚信利益相关主体作为成员单位。",
    jcar_about_us_intro_charter_para_02_content_02:"第五条 FAIR 以理事会作为最高决策机构，理事会采取席位制。每个成员单位委派1位代表作为理事，共同组成理事会。理事会设理事长1人，由在学术诚信与出版伦理领域享有盛誉的国内外专家担任；设常务副理事长1人，负责理事会日常运营管理，由主要发起单位提名，经理事会选举产生。理事会每届任期3年。理事会下设秘书处，负责联合体日常工作。成员单位理事若有调整，需及时报送秘书处，更新理事名单。",
    jcar_about_us_intro_charter_para_02_content_03:"第六条 理事会会议每年召开1次，须有三分之二以上的理事参加方能召开，负责联合体章程修改、年度工作规划、成员单位加入、秘书长、常务副秘书长任命等重大事项的决策。其决议须经到会人数半数以上表决通过方能生效。参会人员因故不能参加表决时，可以委托代表行使所委托的表决权。",
    jcar_about_us_intro_charter_para_02_content_04:"第七条 理事会下设常务理事会，常务理事会由理事长、常务副理事长、秘书长、常务副秘书长、专项组组长及副组长单位理事组成。常务理事会会议根据工作需要不定期召开，负责协调各专项组开展工作，并检查工作推进及落实情况。",
    jcar_about_us_intro_charter_para_02_content_05:"第八条 秘书处由成员单位委派工作人员组成，办公室设在苏州协同开放科学研究中心。设秘书长1位、常务副秘书长1位。秘书长由学术诚信与版权工作委员会提名，常务副秘书长由苏州协同开放科学研究中心提名，经理事长和常务副理事长同意后由理事会任命。秘书处每届任期3年。",
    jcar_about_us_intro_charter_para_02_content_06:"第九条 理事会根据年度工作规划设立专项组，专项组由成员单位自愿加入。专项组设组长及副组长单位各1个，由秘书处提名，经理事长及常务副理事长批准后产生。专项组根据联合体年度工作规划制定工作组计划，经报常务理事会通过后，由组长单位牵头组织实施。初期建议设立以下专项组：",
    jcar_about_us_intro_charter_para_03_title:"第三章 权利及义务",
    jcar_about_us_intro_charter_para_03_content_01_01:"第十条 FAIR 成员单位享有下列权利：",
    jcar_about_us_intro_charter_para_03_content_01_02:"自愿加入联合体，经向秘书处申请、理事会审议通过，即可成为联合体正式成员单位；",
    jcar_about_us_intro_charter_para_03_content_01_03:"可以以联合体成员单位名义开展与学术诚信相关的活动，优先享用联合体工作成果（包括国际OA期刊学术诚信指数数据及报告）和各种资源；",
    jcar_about_us_intro_charter_para_03_content_01_04:"可自愿退出联合体，需提前60天提出书面申请，报送至秘书处，经常务理事会审批后退出，其所委派理事亦自动退出理事会。",
    jcar_about_us_intro_charter_para_03_content_02_01:"第十一条 FAIR 成员单位承担下列义务：",
    jcar_about_us_intro_charter_para_03_content_02_02:"遵守有关法律法规和联合体章程，落实联合体年度工作任务；",
    jcar_about_us_intro_charter_para_03_content_02_03:"为联合体组织的相关会议、活动提供必要的人力和物力支持，共享必要的学术诚信相关数据资源；",
    jcar_about_us_intro_charter_para_03_content_02_04:"自觉维护联合体的声誉和合法权益。",
    jcar_about_us_intro_charter_para_03_content_03_01:"第十二条 理事会理事享有下列权利：",
    jcar_about_us_intro_charter_para_03_content_03_02:"参加联合体组织的内外部会议，及理事会会议，行使表决权，享有对联合体年度工作规划和其他重大决策的知情权、建议权和监督权；",
    jcar_about_us_intro_charter_para_03_content_03_03:"参与联合体各项活动，向联合体各项工作提出意见和建议。",
    jcar_about_us_intro_charter_para_03_content_04_01:"第十三条 理事会理事承担下列义务：",
    jcar_about_us_intro_charter_para_03_content_04_02:"遵守有关法律法规和联合体章程，执行理事会决议；",
    jcar_about_us_intro_charter_para_03_content_04_03:"自觉维护联合体的声誉和合法权益；",
    jcar_about_us_intro_charter_para_03_content_04_04:"理事连续2次不参加且不委派其所在成员单位代表参加理事会会议，自动失去任职资格，所代表的成员单位亦自动退出联合体。",
    jcar_about_us_intro_charter_para_03_content_05_01:"第十四条 常务理事享有下列权利：",
    jcar_about_us_intro_charter_para_03_content_05_02:"参加常务理事会会议；",
    jcar_about_us_intro_charter_para_03_content_05_03:"参与常务理事会各项事项的讨论、提出建议并参与表决。",
    jcar_about_us_intro_charter_para_03_content_06_01:"第十五条 常务理事承担下列义务：",
    jcar_about_us_intro_charter_para_03_content_06_02:"按时参加常务理事会会议，连续2次不出席常务理事会会议，常务理事资格即终止；",
    jcar_about_us_intro_charter_para_03_content_06_03:"为常务理事会各项工作提供意见、建议，以及决策所需的相关支持；",
    jcar_about_us_intro_charter_para_03_content_06_04:"按照联合体年度工作规划，以及理事会、常务理事会的决议，推动各项工作的有序开展。",
    jcar_about_us_intro_charter_para_04_title:"第四章 附则",
    jcar_about_us_intro_charter_para_04_content_01:"第十六条 FAIR 成员单位、理事会全体理事对联合体内部尚在讨论中的工作规划、项目及决策，相关成员单位在联合体内部分享的尚未公开的资料、数据（包括尚未发布的指数原始数据）以及其他经常务理事会确认应当保密的事项，未经常务理事会书面许可，不得对联合体外泄露。",
    jcar_about_us_intro_charter_para_04_content_02:"第十七条 成员单位、理事如有严重违反本章程、触犯相关法律法规或从事任何可能损害联合体利益的相关活动，经联合体理事会会议参会人数半数以上表决通过，可将其退出联合体。",
    jcar_about_us_intro_charter_para_04_content_03:"第十八条 本章程用中文和英文书就，在两种文本不一致时，以中文版本为准，由秘书处负责解释。",
    jcar_about_us_intro_charter_para_04_content_04:"第十九条 本章程经由理事会审议通过后试行。",

    jcar_about_us_member_institutions_title: "负责任研究与学术诚信联合体成员单位",
}
